import styled, { css } from 'styled-components';

export const Container = styled.header`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.layout.spacing(1)};

    h1 {
      color: ${theme.palette.text.main};
      font-size: ${theme.typography.sizes.title1};
    }

    h3 {
      color: ${theme.palette.text.light};
      font-size: ${theme.typography.sizes.title3};
    }

    @media (max-width: ${theme.layout.breakpoints.md}) {
      h1 {
        font-size: ${theme.typography.sizes.title2};
      }

      h3 {
        font-size: ${theme.typography.sizes.body1};
      }
    }
  `}
`;
